/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {transcribeAudio} from '../api'

export const useMutationTranscribeAudio = createReactQueryMutationHook('transcribeAudio', transcribeAudio)
